@if (!item().items){
    <a class="item"
       [ngClass]="{
            'disabled': item().disabled,
            'active': tabMode() && item().name === activeTab()
       }"
       [routerLink]="tabMode() ? null : item().link"
       [routerLinkActive]="tabMode() ? '' : 'active'"
       [routerLinkActiveOptions]="{exact: item().exact}"
       (click)="handleClick($event)">
        @if (item().bi_icon) { <i [class]="['bi',item().bi_icon,'icon']"  ></i>  }
        @if (item().bi_icon_active) { <i [class]="['bi',item().bi_icon_active,'icon-active']"></i>  }
        <span>{{ item().name }}</span>
    </a>
}
@if (item().items){
    <div class="item-group"
         [ngClass]="{'open': isOpen()}"
         tabindex="1"
         [routerLink]="item().link"
         routerLinkActive="active"
         [routerLinkActiveOptions]="{exact: item().exact}">
        <div class="item header"  (click)="handleClick($event)">
            @if (item().bi_icon) { <i [class]="['bi',item().bi_icon,'icon']"  ></i>  }
            @if (item().bi_icon_active) { <i [class]="['bi',item().bi_icon_active,'icon-active']"></i>  }
            <span>{{ item().name }}</span>
            <i class="bi bi-caret-down-fill caret"></i>
        </div>
        <div class="links">
            @for (i of item().items;track $index){
                <a class="item sub-item"
                   [routerLink]="i.link"
                   routerLinkActive="active"
                   (click)="handleClick($event)"
                   [routerLinkActiveOptions]="{exact: i.exact}"  >
                    @if (i.bi_icon) { <i [class]="['bi',i.bi_icon,'icon']"  ></i>  }
                    @if (i.bi_icon_active) { <i [class]="['bi',i.bi_icon_active,'icon-active']"></i>  }
                    <span>{{ i.name }}</span>
                </a>
            }
        </div>
    </div>
}


